import React from "react";

export default function PageHeader({ title }) {
  return (
    <div className="container" style={{ paddingTop: 24 }}>
      <div
        className="page-header"
        style={{
          display: "flex",
          alignItems: "center",
          minHeight: 44,
          marginBottom: 12,
        }}
      >
        <h1 style={{ margin: 0, fontSize: 20, lineHeight: "28px" }}>{title}</h1>
      </div>
    </div>
  );
}
